function buildEmbedSrc(rawUrl) {
  try {
    const url = new URL(rawUrl);
    if (url.hostname.includes('youtube.com')) {
      const id = url.searchParams.get('v');
      return `https://www.youtube.com/embed/${id}?autoplay=1`;
    }
    if (url.hostname === 'youtu.be') {
      return `https://www.youtube.com/embed${url.pathname}?autoplay=1`;
    }
    if (url.hostname.includes('vimeo.com')) {
      return `https://player.vimeo.com/video${url.pathname}?autoplay=1`;
    }
  } catch (_) {}
  return rawUrl;
}

function getOrCreateModal() {
  const existing = document.getElementById('product-story-modal');
  if (existing) return existing;

  const iframe = document.createElement('iframe');
  iframe.className = 'product-story-modal__iframe';
  iframe.dataset.storyIframe = '';
  iframe.src = '';
  iframe.allow = 'autoplay; fullscreen; picture-in-picture';
  iframe.allowFullscreen = true;

  const closeBtn = document.createElement('button');
  closeBtn.className = 'product-story-modal__close';
  closeBtn.setAttribute('aria-label', 'Close video');
  closeBtn.textContent = '✕';

  const inner = document.createElement('div');
  inner.className = 'product-story-modal__inner';
  inner.appendChild(closeBtn);
  inner.appendChild(iframe);

  const modal = document.createElement('div');
  modal.id = 'product-story-modal';
  modal.className = 'product-story-modal';
  modal.setAttribute('aria-modal', 'true');
  modal.setAttribute('role', 'dialog');
  modal.setAttribute('aria-label', 'Video');
  modal.hidden = true;
  modal.appendChild(inner);
  document.body.appendChild(modal);

  const close = () => {
    iframe.src = '';
    modal.hidden = true;
    document.body.style.overflow = '';
  };

  closeBtn.addEventListener('click', close);
  modal.addEventListener('click', (e) => {
    if (e.target === modal) close();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.hidden) close();
  });

  return modal;
}

const MOBILE_BREAKPOINT = 1440;
let _storyAccordionUid = 0;
const _accordionCleanups = new WeakMap();

function initProductStoryAccordion(container) {
  const labelContainer = container.querySelector('.product-story__label-container');
  const imagesContainer = container.querySelector('.product-story__images-container');
  const chevron = container.querySelector('.chevron-down-icon');

  if (!labelContainer || !imagesContainer) return;

  if (!imagesContainer.id) {
    imagesContainer.id = `product-story-panel-${_storyAccordionUid++}`;
  }

  const mq = window.matchMedia(`all`);

  const toggle = () => {
    const isOpen = imagesContainer.dataset.storyOpen === 'true';
    const next = !isOpen;

    imagesContainer.dataset.storyOpen = String(next);
    labelContainer.setAttribute('aria-expanded', String(next));

    if (chevron) {
      chevron.style.transform = next ? 'rotate(180deg)' : 'rotate(0deg)';
    }
  };

  const enableAccordion = () => {
    imagesContainer.dataset.storyOpen = 'false';
    labelContainer.setAttribute('role', 'button');
    labelContainer.setAttribute('tabindex', '0');
    labelContainer.setAttribute('aria-expanded', 'false');
    labelContainer.setAttribute('aria-controls', imagesContainer.id);
    if (chevron) chevron.style.transform = 'rotate(0deg)';
  };

  const disableAccordion = () => {
    delete imagesContainer.dataset.storyOpen;
    labelContainer.removeAttribute('role');
    labelContainer.removeAttribute('tabindex');
    labelContainer.removeAttribute('aria-expanded');
    labelContainer.removeAttribute('aria-controls');
    if (chevron) chevron.style.transform = '';
  };

  labelContainer.addEventListener('click', () => {
    if (mq.matches) toggle();
  });

  labelContainer.addEventListener('keydown', (e) => {
    if (mq.matches && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      toggle();
    }
  });

  const syncState = () => {
    if (mq.matches) {
      if (!imagesContainer.hasAttribute('data-story-open')) {
        enableAccordion();
      }
    } else {
      disableAccordion();
    }
  };

  mq.addEventListener('change', syncState);
  syncState();

  _accordionCleanups.set(container, () => mq.removeEventListener('change', syncState));
}

function initProductStoryVideo(container) {
  initProductStoryAccordion(container);

  container.querySelectorAll('[data-story-video]:not([data-story-init])').forEach((item) => {
    item.dataset.storyInit = '1';

    const open = () => {
      const modal = getOrCreateModal();
      modal.querySelector('[data-story-iframe]').src = buildEmbedSrc(item.dataset.storyVideo);
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    };

    item.addEventListener('click', open);
    item.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
    });
  });
}

document.querySelectorAll('.product-story').forEach(initProductStoryVideo);

document.addEventListener('shopify:section:load', (e) => {
  e.target.querySelectorAll('.product-story').forEach(initProductStoryVideo);
});

document.addEventListener('shopify:section:unload', (e) => {
  e.target.querySelectorAll('.product-story').forEach((container) => {
    const cleanup = _accordionCleanups.get(container);
    if (cleanup) {
      cleanup();
      _accordionCleanups.delete(container);
    }
  });
});
